import { gql } from '@/store/helpers/axios.js'

export default {
  async GET_CODES_BY_CODEGRUPPEN ({ commit }, payload) {
    const query = `query codesByCodegruppe ($input: CodesInput) {
      codesByCodegruppen (input: $input) {
        id
        codegruppenId
        codeIntern
        name
        reihenfolge
      }
    }`

    const variables = {
      input: {
        codeGruppenCodeIntern: payload
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_CODES_BY_CODEGRUPPEN', data.data.codesByCodegruppen)
    }
  },
  async GET_DOCUMENTS_BY_GESUCHSART ({ commit }, payload) {
    const query = `query lGAMetadaten($input: GAMetaDatenInput! 
                                      $order_by: LGAMetadatenSort 
                                      $where: LGAMetadatenFilter){
      lGAMetadaten(input: $input order_by: $order_by where: $where) {
        id
        bezeichnung
        wert
      }
    }`

    const variables = {
      input: {
        gesuchsartId: payload
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_DOCUMENTS_BY_GESUCHSART', data.data.lGAMetadaten)
    }

    return data
  },
  async GET_DOCUMENTS_BY_GESUCHSART_PROJEKTABSCHLUSS ({ commit }, payload) {
    const query = `query lGAMetadatenProjektabschluss($input: GAMetaDatenInput! 
                                      $order_by: LGAMetadatenSort 
                                      $where: LGAMetadatenFilter){
      lGAMetadatenProjektabschluss(input: $input order_by: $order_by where: $where) {
        id
        bezeichnung
        wert
      }
    }`

    const variables = {
      input: {
        gesuchsartId: payload
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_DOCUMENTS_BY_GESUCHSART_PROJEKTABSCHLUSS', data.data.lGAMetadatenProjektabschluss)
    }

    return data
  },
  async GET_CODES_KONTOART ({ commit }) {
    const query = `query codesByCodeGruppenId ($input: CodesInputByIdInput) {
      codesByCodeGruppenId (input: $input) {
        id
        codegruppenId
        codeIntern
        name
        reihenfolge
      }
    }`

    const variables = {
      input: {
        codegruppenId: Number(process.env.VUE_APP_KONTOART_ID)
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_KONTOART', data.data.codesByCodeGruppenId)
    }
    return data
  },
  async GET_CODES_COUNTRIES ({ commit }) {
    const query = `query codesByCodeGruppenId ($input: CodesInputByIdInput) {
      codesByCodeGruppenId (input: $input) {
        id
        codegruppenId
        codeIntern
        name
        reihenfolge
      }
    }`

    const variables = {
      input: {
        codegruppenId: Number(process.env.VUE_APP_COUNTRY_ID)
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_COUNTRIES', data.data.codesByCodeGruppenId)
    }
    return data
  },
  async GET_CODES_PROJEKTABSCHLUSS ({ commit }) {
    const query = `query codesByCodeGruppenId ($input: CodesInputByIdInput) {
      codesByCodeGruppenId (input: $input) {
        id
        codegruppenId
        codeIntern
        name
        reihenfolge
      }
    }`

    const variables = {
      input: {
        codegruppenId: Number(process.env.VUE_APP_PROJEKTABSCHLUSS_ID)
      }
    }

    const { data } = await gql({ query, variables })

    if (!data.errors) {
      commit('SET_PROJEKTABSCHLUSS_SELECTION', data.data.codesByCodeGruppenId)
    }
    return data
  }
}
